<mapfre-modal
  [modalOptions]="uploadingFiles"
  [hideModal]="hideModalOnRoute"
  (closeModal)="resetHideModal($event)"
>
  <div class="modal-body no-margin-top margin-bottom mb8">
    <ng-container *ngIf="isAcmic; else maHeader">
      <hr class="margin-bottom mb16 no-margin-top"/>                              
    </ng-container>
    <ng-template #maHeader>
      <div class="ma-modal-title">{{'Please confirm' | translate}}</div>                                                                
    </ng-template>
    <div class="uploading-files margin-top mt24 text-center">
      <div>
        <img src="./assets/img/images/expired.svg" alt="expired icon" />
      </div>
      <div class="document-message margin-top mt16">
        {{ "If you exit any uploaded files will be lost." }}
      </div>      
    </div>
    <hr class="ma-hr-tag" *ngIf="!isAcmic"> 
    <div class="show-btn-order display-right margin-bottom mb16 margin-top mt24">
      <mapfre-button
        (click)="onClickExit()"
        additionalClasses="ghost secondary small-btn mr-3 modal-small-btn letter-space-17"
        >{{ "Exit" | translate }}
      </mapfre-button>
      <mapfre-button
        (click)="onClickStay()"
        additionalClasses="basic primary small-btn margin-bottom modal-small-btn letter-space-17"
      >
        {{ "Stay here" | translate }}
      </mapfre-button>
    </div>
  </div>
</mapfre-modal>
